import React from 'react';
import styles from './Header.module.css';

const Header = (props) => {

	return (
		<div className={styles.header}>
			<div className={styles.logo}>Glass Studios LTD.</div>
			<p className={styles.description}>The Central Coast's premiere location for glass restoration, chip repair and cutting.
			</p>
			<div className={styles.holder}>
				<button onClick={() => props.modal(true)} className={styles.contact}>Contact Us</button>
				<button onClick={() => props.modal(true)} className={styles.services}>Our Services</button>
			</div>
		</div>
	);

};

export default Header;